import React from 'react';
import { makeStyles } from '@material-ui/core';
import udafLogo from 'img/udaf-logo.svg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: '1em',
    '& h1, & h4': {
      fontSize: '1.125em',
      lineHeight: '1.5em',
      margin: '0',
      fontWeight: '400',
    },
    '& span': {
      color: theme.custom.primary,
    },
  },
  logo: {
    width: '80px',
    marginRight: '1em',
  },
}));

const Header = () => {
  const classes = useStyles();

  return (
    <header className={classes.wrapper}>
      <img className={classes.logo} src={udafLogo} alt="Utah Brands" />
      <div>
        <h1>
          Utah Department of<br />
          Agriculture and Food
        </h1>
        <h4>
          Brand Inspection certificate [<span>Owner</span>'s Copy]
        </h4>
      </div>
    </header>
  );
};

export default Header;
